<template>
    <div style="background-color: white;" uk-sticky="show-on-up: true">
        <nav class=" uk-container uk-navbar-container uk-margin " uk-navbar style="background-color: white">
            <div class="uk-navbar-left">

                <a class="uk-navbar-item uk-logo" href="#">
                    <img src="/logo.png" style="max-height: 120px; max-width: 120px; height: auto; width: auto; margin-top: -10px" alt="">
                </a>

                <ul class="uk-navbar-nav uk-visible@m" >
                    <li><router-link to="/" class="uk-text-capitalize" style="font-size: 16px; margin-top: 15px">Home</router-link></li>
                    <li><router-link to="/aboutus" class="uk-text-capitalize" style="font-size: 16px; margin-top: 15px">About Us</router-link></li>
                    <li><router-link to="/productservices" class="uk-text-capitalize" style="font-size: 16px; margin-top: 15px">Products & Services</router-link></li>
                    <!--<li><a href="#" class="uk-text-capitalize" style="font-size: large; margin-top: 15px">Pricing</a></li>
                    <li><a href="#" class="uk-text-capitalize" style="font-size: large; margin-top: 15px">Customers</a></li>-->
                </ul>

            </div>
            <div class="uk-navbar-right uk-hidden@m">
                <button class="uk-button uk-button-link uk-margin-small-right" type="button" uk-toggle="target: #offcanvas-nav-primary" uk-icon="menu"></button>
            </div>
            <div class="uk-navbar-right uk-visible@m">
                <!--<ul class="uk-navbar-nav" >
                    <li><router-link to="/help" class="uk-text-capitalize" style="font-size: large; margin-top: 15px">Help</router-link></li>
                </ul>-->
                <div class="uk-navbar-item">
                    <form action="javascript:void(0)">

                        <router-link
                                to="/help/videos"
                                class="uk-button uk-button-default uk-text-capitalize"
                                style=" margin-top: 15px; font-size: 16px;"
                        >Help</router-link>
                    </form>
                </div>
                <div class="uk-navbar-item">
                    <form action="javascript:void(0)">

                        <router-link
                                to="/contactus"
                                class="uk-button uk-button-secondary uk-text-capitalize"
                                style="background-color: #800000; color: white !important; margin-top: 15px;  font-size: 16px;"
                        >Contact Us</router-link>
                    </form>
                </div>
            </div>
        </nav>

        <div id="offcanvas-nav-primary" uk-offcanvas="overlay: true">
            <div class="uk-offcanvas-bar uk-flex uk-flex-column" style="background-color: #fff">

                <ul class="uk-nav uk-nav-primary  uk-margin-auto-vertical">
                    <li class="">
                        <a class="uk-navbar-item uk-logo" href="#">
                            <img src="/logo.png" style="max-height: 120px; max-width: 120px; height: auto; width: auto; margin-top: -10px" alt="">
                        </a>
                    </li>
                    <li><router-link to="/" style="font-size: large"> Home</router-link></li>
                    <li><router-link to="/aboutus" style="font-size: large"> About Us</router-link></li>
                    <li><router-link to="/productservices" style="font-size: large"> Products & Services</router-link></li>
                    <li class="uk-nav-divider"></li>
                    <li><router-link to="/help/videos" style="font-size: large"> Help</router-link></li>
                    <li><router-link to="/contactus" style="font-size: large"> Contact Us</router-link></li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "navbar"
    }
</script>

<style scoped>
    a{
        color: #800000 !important;

    }
</style>